import React from 'react';
import PropTypes from 'prop-types';

const HeartRed = ({ fill }) => (
  <svg
    width="19px"
    height="17px"
    viewBox="0 0 19 17"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Saved" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-331.000000, -184.000000)" fill={fill}>
        <path
          d="M336.055851,184 C334.754617,184 333.453286,184.50908 332.471723,185.534654 C330.508476,187.585828 330.510375,190.873418 332.471723,192.926414 L339.967004,200.77399 C340.103975,200.918332 340.295174,201 340.49587,201 C340.695618,201 340.886814,200.918332 341.024735,200.77399 C343.525516,198.161616 346.027027,195.546325 348.527565,192.93395 C350.490812,190.882777 350.490812,187.593242 348.527565,185.542191 C346.564318,183.491139 343.322677,183.491017 341.359309,185.542191 L340.499449,186.43102 L339.63959,185.534581 C338.657978,184.508983 337.356744,184 336.055462,184 L336.055851,184 Z"
          id="heart-red"
        />
      </g>
    </g>
  </svg>
);

HeartRed.propTypes = {
  fill: PropTypes.string,
};

HeartRed.defaultProps = {
  fill: '#F16159',
};

export default HeartRed;
